import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { LoginService } from '@app/core/services/login/login.service';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from "environments/environment";
import { LoginAndSignUpDataComponent, PopupService } from '../../../shared/services/popup/popup.service';
import { LoginComponent } from '../../../auth/login/login.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPassForm: FormGroup;
  redirectTo: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private loaderService: LoaderService,
    private popupService: PopupService,
    public dialogRefLogin: MatDialogRef<LoginComponent>,
    private notification: NotificationService, private loginService: LoginService, private activatedRoute: ActivatedRoute,
    public dialogRef: MatDialogRef<ForgotPasswordComponent>) {
    this.forgotPassForm = formBuilder.group({
      ForgetPasswordEmailId: ['', Validators.compose([Validators.required,
      Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')])]
    });
  }

  ngOnInit() {
    if (location.pathname.split("/")[1] == "RecoverPassword" && location.pathname.split("/")[1] != "") {
      const urlParams = new URLSearchParams(window.location.search);
      this.redirectTo = urlParams.get('redirect');
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.forgotPassForm.controls; }

  /**Function to close forgot password dialog */
  fn_CloseDialog(): void {
    this.dialogRef.close();

    // redirect to Shopify Application after dialog closes
    if (this.redirectTo.length > 0)
      window.location.href = this.redirectTo;

  }

  /**Function called on forgot password submit button */
  onSubmit(forgotPassForm: FormGroup) {
    try {
      this.loaderService.show();
      this.loginService.forgotPassword(forgotPassForm.value.ForgetPasswordEmailId, this.redirectTo)
        .subscribe((res: any) => {
          if (res.StatusCode === 200) {
            this.notification.success(res.Message, 'Password Reset');
          } else if (res.StatusCode === 400) {
            this.notification.info(res.Message, 'Password Reset');
          } else {
            this.notification.error(res.Message, 'Error');
          }
          this.loaderService.hide();
          this.fn_CloseDialog();
        }, err => {
          this.loaderService.hide();
          this.notification.error('An error occured', 'Error');
          this.fn_CloseDialog();
        });
    } catch (error) {
      this.loaderService.hide();
    }
  }

  openloginFormDialog(): void {
    this.popupService.openLogin();
    this.closeDialog();
  }

  closeDialog(): void {
    $(".body").css("filter", "blur(0px)");
    this.dialogRefLogin.close();
  }
}
